module.exports = __webpack_public_path__ + "static/error-do-example-dc648981512b4f0dcece76d109b8b319.svg";